import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopBannerComponent } from './top-banner.component';

@NgModule({
  declarations: [],
  imports: [CommonModule, TopBannerComponent],
  exports: [TopBannerComponent],
})
export class TopBannerModule {}
